/* eslint-disable no-mixed-spaces-and-tabs */
import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';

export default {
    data() {
        return {
            records: [],
        };
    },

    computed: {
        mappedEvictions() {
            return this.evictionRecords.map((item) => {
                const detail = item.case.case;
                const fileDate = Array.isArray(detail)
                    ? ''
                    : this.getEvictionFileDate(detail);
                const info = this.getInfo(item);
                return {
                    ...item,
                    fileDate,
                    info,
                };
            });
        },
        charges() {
            return this.records
                .sort(
                    (a, b) =>
                        this.$_.get(a, 'tag.degree', '') >
                        this.$_.get(b, 'tag.degree', '')
                )
                .map((item) => this.mapRecordItem(item));
        },
    },
    methods: {
        getCounts() {
            return this.charges.length > 0
                ? [
                      {
                          label: 'Felonies',
                          color: this.getDegreeColor('FELONY'),
                          colorOption: 1,
                          icon: 'mdi-gavel',
                          count: this.records.filter(
                              (item) =>
                                  this.$_.get(item, 'tag.degree', '') ===
                                  'FELONY'
                          ).length,
                      },
                      {
                          label: 'Misdemeanors',
                          color: this.getDegreeColor('MISDEMEANOR'),
                          colorOption: 2,
                          icon: 'mdi-scale-balance',
                          count: this.records.filter(
                              (item) =>
                                  this.$_.get(item, 'tag.degree', '') ===
                                  'MISDEMEANOR'
                          ).length,
                      },
                      {
                          label: 'Violations',
                          color: this.getDegreeColor('VIOLATION'),
                          colorOption: 3,
                          icon: 'mdi-script',
                          count: this.records.filter(
                              (item) =>
                                  this.$_.get(item, 'tag.degree', '') ===
                                  'VIOLATION'
                          ).length,
                      },
                      {
                          label: 'Evictions',
                          color: this.getDegreeColor('EVICTION'),
                          colorOption: 4,
                          icon: 'mdi-home-export-outline',
                          count: this.records.filter(
                              (item) => item.type === 'eviction'
                          ).length,
                      },
                  ]
                : [];
        },
        mapRecordItem(item) {
            item.degreeColor = this.getDegreeColor(
                this.$_.get(item, 'tag.degree', '')
            );
            const {
                color: dispositionColor,
                icon: dispositionIcon,
            } = this.getDisposition(item.tag.disposition);

            const {
                dispositionDate,
                fileDate,
                offenseDate,
                convictionDate,
            } = this.getDates(item);

            const info = this.getInfo(item);

            const { status, disposition, degree } = item.tag;

            return {
                ...item,
                status,
                disposition,
                degree,
                dispositionColor,
                dispositionIcon,
                dispositionDate,
                fileDate,
                offenseDate,
                convictionDate,
                info,
            };
        },
        getInfo(item, prefix = 'tag.') {
            let infoItems = [
                {
                    label: 'Category',
                    type: 'chip',
                    text: this.$_.get(item, `${prefix}name`, ''),
                    icon: 'mdi-form-select',
                },
                {
                    label: 'Case ID',
                    type: 'label',
                    text: this.$_.get(item, `${prefix}detail.caseId`),
                    icon: 'mdi-briefcase',
                },
            ];
            if (this.$_.has(item, `${prefix}detail.statute`)) {
                infoItems.push({
                    label: 'Statute',
                    type: 'label',
                    text: this.$_.get(item, `{$prefix}detail.statute`),
                    icon: 'mdi-script-text',
                });
            }
            if (this.$_.has(item, `${prefix}detail.caseType`)) {
                infoItems.push({
                    label: 'Case Type',
                    type: 'label',
                    text: this.$_.get(item, `${prefix}detail.caseType`),
                    icon: 'mdi-briefcase-check',
                });
            }
            if (this.$_.has(item, `${prefix}detail.judgement`)) {
                infoItems.push({
                    label: 'Judgement',
                    type: 'label',
                    text: this.$_.get(item, `${prefix}detail.judgement`),
                    icon: 'mdi-gavel',
                });
            }
            return infoItems;
        },
        getDates(item) {
            const {
                file_date: itemFileDate,
                offense_date: itemOffenseDate,
                conviction_date: itemConvictionDate,
                disposition_date: itemDispositionDate,
            } = item;
            const {
                file_date: fromFileDate,
                offense_date: fromOffenseDate,
                conviction_date: fromConvictionDate,
                disposition_date: fromDispositionDate,
            } = item.date_diff_for_humans;

            const fileDate = {
                icon: 'mdi-calendar',
                label: 'File Date',
                date: itemFileDate ?? '',
                from: fromFileDate,
            };
            const offenseDate = {
                icon: 'mdi-calendar-cursor',
                label: 'Offense Date',
                date: itemOffenseDate ?? '',
                from: fromOffenseDate,
            };
            const dispositionDate = {
                icon: 'mdi-calendar-check',
                label: 'Disposition Date',
                date: itemDispositionDate ?? '',
                from: fromDispositionDate,
            };
            const convictionDate = {
                icon: 'mdi-calendar-check',
                label: 'Disposition Date',
                date: itemConvictionDate ?? '',
                from: fromConvictionDate,
            };
            return { fileDate, offenseDate, dispositionDate, convictionDate };
        },
        getEvictionFileDate(item) {
            dayjs.extend(relativeTime);

            let { fileDate = '' } = item ?? {};
            // Remove time
            fileDate = fileDate.split(' ').shift();
            return {
                icon: 'mdi-calendar',
                label: 'File Date',
                date:
                    fileDate.length > 0
                        ? dayjs(fileDate).format('MM/DD/YYYY')
                        : '',
                from: fileDate.length > 0 ? dayjs(fileDate).fromNow() : '',
            };
        },
        getDegreeColor(degree) {
            switch (degree) {
                case 'VIOLATION':
                    return 'primary darken-2';
                case 'MISDEMEANOR':
                    return 'warning darken-2';
                case 'FELONY':
                case 'SEX OFFENDER':
                case 'TERRORIST':
                    return 'error darken-2';
                default:
                    return 'grey darken-1';
            }
        },
        getDisposition(disposition) {
            switch (disposition.toUpperCase()) {
                case 'DISMISSED':
                    return {
                        color: 'grey darken-2',
                        icon: 'mdi-close-circle',
                    };
                case 'CONVICTED':
                case 'GUILTY':
                    return {
                        color: 'accent darken-2',
                        icon: 'mdi-check-circle',
                    };
                case 'PAID FINE & COST':
                    return {
                        color: 'warning darken-2',
                        icon: 'mdi-check-circle',
                    };
                default:
                    return {
                        color: 'grey darken-3',
                        icon: 'mdi-information',
                    };
            }
        },
    },
};
